var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('div',{staticClass:"shadow-25"},[_c('v-header',{attrs:{"title":_vm.$metaInfo.title,"icon":"public"}}),_vm._v(" "),_c('card',{attrs:{"width":"100%"}},[_c('p',[_vm._v("Tabela de marcados")])])],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6333a940","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/backoffice/market/management.vue
// module id = C3cY
// module chunks = 44